export const LOGO_URL = "https://customer-assets.emergentagent.com/job_f4b0fe2d-e1ed-47ba-ac88-d35878aedb22/artifacts/dqpnt070_Andstel%20Group_SSa-R06a_Mil.png";

export const CONTACT = {
  phone: "0405 737 355",
  phoneRaw: "0405737355",
  email: "andrew@andstelgroup.com",
  address: "PO Box 210, Sunshine, VIC",
  abn: "74 663 157 185",
};

export const SERVICES = [
  {
    slug: "residential-electrical",
    title: "Residential Electrical",
    short: "Safe, reliable wiring, lighting and power upgrades for homes across Melbourne.",
    long:
      "From new power points and downlights to full home rewires, our licensed electricians deliver residential work that meets Australian standards and looks the part. We work clean, communicate clearly, and back every job.",
    icon: "Home",
    image: "https://images.pexels.com/photos/33531830/pexels-photo-33531830.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "commercial-electrical",
    title: "Commercial Electrical",
    short: "Fit-outs, lighting design, data cabling and preventative maintenance for businesses.",
    long:
      "We partner with builders, property managers and business owners to deliver commercial electrical projects on time and on budget. Shop fit-outs, warehouse lighting, three-phase upgrades and scheduled maintenance.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzgyOTAxNDU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "solar-installations",
    title: "Solar Installations",
    short: "CEC-compliant solar PV designed, engineered and installed for your roof.",
    long:
      "We size, design and install solar systems that actually pay off — Tier 1 panels, quality inverters, monitoring apps and rebates handled. Straight-talking advice, no pushy sales.",
    icon: "Sun",
    image: "https://images.pexels.com/photos/9875418/pexels-photo-9875418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "battery-installations",
    title: "Battery Installations",
    short: "Store the sun. Home battery systems paired to your solar and load profile.",
    long:
      "Add resilience and cut evening grid usage with a home battery. We install Tesla Powerwall, Sungrow and other leading systems, correctly sized to your consumption and integrated with your solar.",
    icon: "BatteryCharging",
    image: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODI5MDE0NjB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "ev-chargers",
    title: "EV Chargers",
    short: "Home and workplace EV charger install — Tesla, Wallbox, Ocular and more.",
    long:
      "We plan the cable run, upgrade the switchboard if needed, and install a compliant, warrantied EV charger. OCPP-ready, load-managed and ready for any brand of car.",
    icon: "Plug",
    image: "https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxlbGVjdHJpYyUyMHZlaGljbGUlMjBjaGFyZ2luZ3xlbnwwfHx8fDE3ODI5MDE0NTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "switchboard-upgrades",
    title: "Switchboard Upgrades",
    short: "Modernise old fuse boards with safety switches and higher capacity.",
    long:
      "If your board still has ceramic fuses, you're overdue. We upgrade to modern circuit breakers, RCBOs and split-load protection — safer, code-compliant, and ready for solar and EV loads.",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MTM4MzB8MHwxfHNlYXJjaHwxfHxzd2l0Y2hib2FyZHxlbnwwfHx8fDE3ODI5MDA5MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "general-maintenance",
    title: "General Electrical Maintenance",
    short: "Preventative testing, safety inspections and rapid fault-finding.",
    long:
      "Small fault, big worry? We diagnose and fix — plus scheduled testing, tagging, RCD checks and pre-purchase electrical inspections. Prompt, tidy, and always compliant.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MTM4MzB8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHRvb2xzfGVufDB8fHx8MTc4Mjg5OTM0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "heating-cooling",
    title: "Heating & Cooling",
    short: "Split systems, ducted splits, multi-head units and all HVAC services.",
    long:
      "Keep your home comfortable year-round. We supply and install split systems, ducted split units, multi-head systems and handle all heating and cooling servicing — sized correctly for your space, quietly commissioned, and backed by manufacturer warranty.",
    icon: "Thermometer",
    image: "https://images.unsplash.com/photo-1631545308456-9f5f80daa1c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MTM4MzB8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzgyOTAxNDU5fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const MELBOURNE_METRO = [
  "Sunshine", "Footscray", "Werribee", "Point Cook", "Altona", "Yarraville",
  "Williamstown", "Essendon", "Moonee Ponds", "Brunswick", "Coburg", "Preston",
  "Northcote", "Fitzroy", "Carlton", "Richmond", "South Yarra", "Prahran",
  "St Kilda", "Elwood", "Brighton", "Caulfield", "Malvern", "Hawthorn",
  "Kew", "Camberwell", "Box Hill", "Doncaster", "Ringwood", "Croydon",
  "Dandenong", "Berwick", "Cranbourne", "Frankston", "Mornington",
  "Melton", "Sunbury", "Craigieburn", "Epping", "Reservoir", "Bundoora",
];

export const REGIONAL_VIC = [
  "Geelong", "Ballarat", "Bendigo", "Shepparton", "Bacchus Marsh",
  "Torquay", "Ocean Grove", "Kyneton", "Woodend", "Gisborne",
  "Warragul", "Traralgon", "Wonthaggi", "Phillip Island",
  "Castlemaine", "Daylesford", "Mansfield", "Seymour",
];

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-home-link" },
  { to: "/services", label: "Services", testId: "nav-services-link" },
  { to: "/areas", label: "Areas", testId: "nav-areas-link" },
  { to: "/about", label: "About", testId: "nav-about-link" },
  { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];
